import { PlusOutlined } from '@ant-design/icons';
import { message } from '@repo/ui';
import {
  Button, Flex, Form, Input, Popover, Tag, Tooltip, Typography,
} from 'antd';
import { useCallback, useMemo, useState } from 'react';

import styles from './ModifyWebhookDrawer.module.scss';

type Header = {
  key: string;
  value: string;
};

export default function CustomHeaderUI({
  value,
  onChange,
}: {
  value?: Header[];
  onChange?: (headers: Header[]) => void;
}) {
  const [tmpHeader, setTmpHeader] = useState<Header>({ key: '', value: '' });

  const handleAddHeader = useCallback(() => {
    if (tmpHeader.key.trim().length && tmpHeader.value.trim().length) {
      onChange?.([...(value || []), tmpHeader]);
      setTmpHeader({ key: '', value: '' });
    } else {
      message.error('Please enter a valid key and value');
    }
  }, [onChange, tmpHeader, value]);

  const AddHeader = useMemo(() => (
    <Flex vertical gap={8}>
      <Typography.Text>Add Custom Header</Typography.Text>
      <Form.Item label="Name" required className={styles.popoverItem}>
        <Input
          placeholder="Enter Name"
          value={tmpHeader.key}
          onChange={(e) => setTmpHeader({ ...tmpHeader, key: e.target.value })}
        />
      </Form.Item>
      <Form.Item label="Value" required className={styles.popoverItem}>
        <Input
          placeholder="Enter Value"
          value={tmpHeader.value}
          onChange={(e) => setTmpHeader({ ...tmpHeader, value: e.target.value })}
        />
      </Form.Item>
      <Button
        type="primary"
        className={styles.popoverButton}
        onClick={handleAddHeader}
      >
        Add
      </Button>
    </Flex>
  ), [handleAddHeader, tmpHeader]);

  const handleRemoveHeader = useCallback((header: Header) => {
    onChange?.((value || []).filter((h) => h.key !== header.key));
  }, [onChange, value]);

  return (
    <Flex gap={8} className={styles.headerContainer}>
      {(value || []).map((header) => (
        <Tooltip title={header.value} key={header.key}>
          <Tag closable onClose={() => handleRemoveHeader(header)}>{header.key}</Tag>
        </Tooltip>
      ))}
      <Popover
        content={AddHeader}
        trigger="click"
        placement="right"
        arrow
      >
        <Button type="link" icon={<PlusOutlined />}>New Header</Button>
      </Popover>
    </Flex>
  );
}
